import { render } from "./ghat-know-about.vue?vue&type=template&id=173f8dea&scoped=true"
import script from "./ghat-know-about.vue?vue&type=script&lang=js"
export * from "./ghat-know-about.vue?vue&type=script&lang=js"

import "./ghat-know-about.vue?vue&type=style&index=0&id=173f8dea&scoped=true&lang=css"
import "./ghat-know-about.vue?vue&type=style&index=1&id=173f8dea&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173f8dea"]])

export default __exports__